import React from 'react'
import { Box, Grid, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Checkbox, Typography, ButtonGroup } from '@material-ui/core'
import { HeaderBlock } from '../../components/header-block/HeaderBlock'
import PageContainer from '../../components/page-container/PageContainer'
import Search from '../../components/search/Search'
import SimpleTable from '../../components/table/Table'
import { PagePlaceholder } from '../../components/page-placeholder/PagePlaceholder'
import { useState } from 'react'
import { getIcon } from '../../icon/icon'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCustomerFlags, getCustomerFlag, upsertCustomerFlag, deleteCustomerFlag } from '../../state/actions/CustomerFlagActions'
import { makeStyles } from '@material-ui/styles'
import DropdownSelect from '../../components/dropdown-select/DropdownSelect'
import { Loading } from '../../components/loading/Loading'
import { DeleteModal } from '../../containers/delete-modal/DeleteModal'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    downloadImage: {
        width: "20px"
    },
    label: {
        margin: "6px"
    }
})

export default function ListCustomerFlags(props) {

    const customerFlags = useSelector(state => state.CustomerFlagReducer.customerFlags)
    const currentCustomerFlag = useSelector(state => state.CustomerFlagReducer.currentCustomerFlag)

    const dispatch = useDispatch()
    const classes = useStyles()
    const [t, i18n] = useTranslation()

    const [selected, setSelected] = useState([])
    const [searchedData, setSearchedData] = useState([])
    const [originalData, setOriginalData] = useState([])
    const [editedCurrentCustomerFlag, setEditedCurrentCustomerFlag] = useState(null)

    const [loading, setLoading] = useState(false)
    const [editCustomerFlagModalOpen, setEditCustomerFlagModalOpen] = useState(false)

    const [fetchCustomerFlags, setFetchCustomerFlags] = useState(true)
    const [errors, setErrors] = useState({})

    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [customerFlagToDelete, setCustomerFlagToDelete] = useState([])

    const [newCustomerFlagModalOpen, setNewCustomerFlagModalOpen] = useState(false)

    useEffect(() => {
        if (fetchCustomerFlags == true) {
            setLoading(true)
            dispatch(getCustomerFlags(() => {
                setLoading(false)
                setFetchCustomerFlags(false)
            }))
        }
    }, [fetchCustomerFlags])

    useEffect(() => {
        setSearchedData(createData(customerFlags))
        setOriginalData(createData(customerFlags))
    }, [customerFlags])

    useEffect(() => {
        if (currentCustomerFlag != null && currentCustomerFlag.id != null) {
            setEditedCurrentCustomerFlag(currentCustomerFlag)
        }
    }, [currentCustomerFlag])

    function createData(customerFlags) {
        const customerFlagKeys = Object.keys(customerFlags);

        return customerFlagKeys.map(customerFlagKey => {
            const customerFlag = customerFlags[customerFlagKey];
            return {
                id: customerFlag.id,
                Name: customerFlag.Name,
                SuperList: customerFlag.SuperList || "-",
                HasPermission: customerFlag.HasPermission,
                Order: customerFlag.Order,
                SubOrder: customerFlag.SubOrder != null ? customerFlag.SubOrder : "-",
            };
        });
    }

    function getCustomerFlagsById(customerFlagsIds) {
        if (customerFlagsIds != null) {
            return customerFlagsIds.map(customerFlagsIds => {
                const customerFlag = customerFlags[customerFlagsIds];

                if (customerFlag != null) {
                    return { id: customerFlag.id, Name: customerFlag.Name };
                }

                return {};
            });
        }

        return [];
    }

    function editCustomerFlag(id) {
        dispatch(getCustomerFlag(id, () => {
            setEditCustomerFlagModalOpen(true)
        }))
    }

    function handleDeleteCustomerFlag() {

        setCustomerFlagToDelete(selected)
        setEditCustomerFlagModalOpen(false)
        setDeleteModalOpen(true)
    }

    function createHeaders() {
        return [
            {
                id: "Name",
                clickable: true,
                align: "left",
                label: t('common.name'),
                type: "label"
            },
            {
                id: "id",
                clickable: false,
                align: "left",
                label: t('common.id'),
                type: "label"
            },
            {
                id: "SuperList",
                clickable: false,
                align: "left",
                label: t('customer-flag.super-list'),
                type: "label"
            },
            {
                id: "HasPermission",
                clickable: false,
                align: "left",
                label: t('customer-flag.has-permission'),
                type: "tag",
                color: "green"
            },
            {
                id: "Order",
                clickable: false,
                align: "left",
                label: t('customer-flag.order'),
                type: "label"
            },
            {
                id: "SubOrder",
                clickable: false,
                align: "left",
                label: t('customer-flag.sub-order'),
                type: "label"
            }
        ];
    }

    function createCells(headers) {
        let cells = [];

        headers.forEach(header => {
            let cell = {};

            cell.id = header.id;

            cell.handleClick = (event, row) => {
                editCustomerFlag(row.id)
            };

            cell.align = header.align;
            cell.clickable = header.clickable;
            cell.type = header.type;

            cells.push(cell);
        });

        return cells;
    }

    function renderData() {
        const headers = createHeaders();
        const cells = createCells(headers);

        if (searchedData.length > 0) {
            return (
                <SimpleTable
                    isSelectable
                    handleSelection={selectedItems => setSelected(selectedItems)}
                    dataId={"id"}
                    cells={cells}
                    headers={headers}
                    rows={searchedData}
                    nonFixed
                />
            );
        } else {
            return (
                <PagePlaceholder
                    image={getIcon("flag.svg")}
                    text={t('customer-flag.no-customer-flags')}
                />
            );
        }
    }

    function handleSaveCustomerFlag() {
        const customerFlag = Object.assign({}, editedCurrentCustomerFlag)
        var badData = false

        const newOrder = parseInt(customerFlag.Order)
        var newSubOrder = null
        if (customerFlag.SubOrder != null) {
            newSubOrder = parseInt(customerFlag.SubOrder)
        }


        if (Number.isNaN(newOrder)) {
            const textErrors = Object.assign({}, errors)
            textErrors.Order = t('common.please-input-number')
            setErrors(textErrors)
            badData = true
        }
        if (Number.isNaN(newSubOrder)) {
            const textErrors = Object.assign({}, errors)
            textErrors.SubOrder = t('common.please-input-number')
            setErrors(textErrors)
            badData = true
        }

        if (!badData) {
            customerFlag.Order = newOrder
            customerFlag.SubOrder = newSubOrder
            setErrors({})
            dispatch(upsertCustomerFlag(customerFlag, () => {
                setNewCustomerFlagModalOpen(false)
                setEditCustomerFlagModalOpen(false)
                setFetchCustomerFlags(true)
            }))
        }
    }

    function createNewCustomerFlag() {
        setEditedCurrentCustomerFlag({
            "Name": "",
            "SuperList": null,
            "HasPermission": true,
            "Order": 0,
            "SubOrder": 0
        })
        setNewCustomerFlagModalOpen(true)
        setEditCustomerFlagModalOpen(true)
    }

    function keySwitch(key) {
        const headers = {
            Name: {
                key: "Name",
                label: t('common.name')
            },
            SuperList: {
                key: "SuperList",
                label: t('customer-flag.super-list')
            },
            HasPermission: {
                key: "HasPermission",
                label: t('customer-flag.has-permission')
            },
            Order: {
                key: "Order",
                label: t('customer-flag.order')
            },
            SubOrder: {
                key: "SubOrder",
                label: t('customer-flag.sub-order')
            }
        }

        switch (key) {
            case "HasPermission":
                return (
                    <Grid container>
                        <Grid item xs={11}>
                            <Typography className={classes.label}>
                                {t('customer-flag.has-permission')}
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                onClick={(event) => {
                                    const customerFlag = Object.assign({}, editedCurrentCustomerFlag)
                                    customerFlag[key] = event.target.checked

                                    setEditedCurrentCustomerFlag(customerFlag)
                                }}
                                checked={editedCurrentCustomerFlag[key]}
                            />
                        </Grid>
                    </Grid>
                )
            case "Order":
            case "SubOrder":
                return (
                    <TextField
                        label={headers[key].label}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        value={editedCurrentCustomerFlag[key]}
                        helperText={errors[key]}
                        error={errors[key] != null}
                        onChange={(event) => {
                            const customerFlag = Object.assign({}, editedCurrentCustomerFlag)
                            var data = event.target.value

                            customerFlag[key] = data
                            setEditedCurrentCustomerFlag(customerFlag)
                        }}
                    />
                )


            default:
                return (
                    <TextField
                        label={headers[key].label}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        value={editedCurrentCustomerFlag[key]}
                        onChange={(event) => {
                            const customerFlag = Object.assign({}, editedCurrentCustomerFlag)
                            var data = event.target.value

                            customerFlag[key] = data
                            setEditedCurrentCustomerFlag(customerFlag)
                        }}
                    />
                )
        }
    }

    function editCustomerFlagModal() {
        return (
            <Dialog open={editCustomerFlagModalOpen}>
                <DialogTitle>
                    {newCustomerFlagModalOpen ? t('customer-flag.new') : t('customer-flag.edit', { flagName: editedCurrentCustomerFlag != null ? editedCurrentCustomerFlag.Name : "-" })}
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        {editedCurrentCustomerFlag != null ?
                            Object.keys(editedCurrentCustomerFlag).map((key) => {
                                if (key == "id") {
                                    return null
                                }
                                return (
                                    < Grid item xs={12} >
                                        {keySwitch(key)}
                                    </Grid>
                                )
                            }) :
                            null
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setNewCustomerFlagModalOpen(false)
                            setEditCustomerFlagModalOpen(false)
                            setEditedCurrentCustomerFlag(null)
                        }}
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button
                        onClick={() => {
                            handleSaveCustomerFlag()
                        }}
                    >
                        {t('common.save')}
                    </Button>
                </DialogActions>
            </Dialog >
        )
    }

    function deleteModal() {
        return (
            <DeleteModal
                data={getCustomerFlagsById(customerFlagToDelete)}
                open={deleteModalOpen}
                handleCancel={() => {
                    setDeleteModalOpen(false)
                    setCustomerFlagToDelete([])
                }}
                handleDone={(data) => {
                    const ids = data.map(item => item.id)
                    dispatch(deleteCustomerFlag(ids, () => {
                        setDeleteModalOpen(false)
                        setCustomerFlagToDelete([])
                        setFetchCustomerFlags(true)
                    }))
                }}
            />
        )
    }

    return (
        <Box>
            <HeaderBlock
                title={t('customer-flag.customer-flags')}
                right={
                    <Grid container spacing={2} alignItems="center" justify="flex-end">
                        <Grid item>
                            <Search
                                searchField={"Name"}
                                secondaryFields={["id", "SuperList"]}
                                returnSearchMatches={data => {
                                    setSearchedData(data)
                                }}
                                data={originalData}
                                searchTitle={t('customer-flag.search')}
                            />
                        </Grid>
                        <Grid item>
                            <ButtonGroup>
                                <Button
                                    disabled={selected.length == 0}
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        handleDeleteCustomerFlag()
                                    }}
                                >
                                    {t('common.delete')}
                                </Button> :
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => {
                                        createNewCustomerFlag()
                                    }}
                                >
                                    {t('customer-flag.new')}
                                </Button>
                            </ButtonGroup>

                        </Grid>
                    </Grid>
                }
            />

            {editCustomerFlagModal()}
            {deleteModal()}

            <PageContainer hasFooter>
                {loading ? <Loading /> : renderData()}
            </PageContainer>
        </Box>
    )
}
